import { type RefObject, useEffect } from 'react';

export const useAutoFocus = (
  ref: RefObject<HTMLElement | null>,
  requestId: number,
  enabled: boolean
) => {
  useEffect(() => {
    if (!enabled) return;
    const el = ref.current;
    setTimeout(() => el?.focus(), 0);
  }, [requestId, enabled, ref]);
};
